import { Component, OnInit } from '@angular/core'
import { OccConfig } from '@spartacus/core'
import { CurrentProductService } from '@spartacus/storefront'
import { Observable } from 'rxjs'
import { ProductDetailsService } from '../../../services/product.service'

@Component({
    selector: 'app-custom-product-details-tab',
    templateUrl: './custom-product-details-tab.component.html',
    styleUrls: ['./custom-product-details-tab.component.scss'],
    standalone: false
})
export class CustomProductDetailsTabComponent implements OnInit {
  product$: Observable<any>

  constructor(
    protected currentProductService: CurrentProductService,
    private occConfig: OccConfig,
    private productDetailsService: ProductDetailsService
  ) {}

  ngOnInit(): void {
    this.product$ = this.productDetailsService.getProductDetail$()
  }

  getCertificationLogo(certificationLogo: string): string {
    const siteBaseUrl: string = this.occConfig.backend.occ.baseUrl
    return siteBaseUrl + certificationLogo
  }
}
